import React from "react";

interface BackArrowProps {
  onClick: () => void;
  text: string;
  className?: string;
}

export const BackArrow: React.FC<BackArrowProps> = ({
  onClick,
  text,
  className = "",
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      <button
        onClick={onClick}
        className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors duration-200"
      >
        <span className="text-xl">←</span>
        <span>{text}</span>
      </button>
    </div>
  );
};
